import { useEffect, useState } from "react";
import { useLocation, Navigate } from "react-router-dom";
import axios from "axios";
import { API } from "@/App";
import { Loader2 } from "lucide-react";
import NotFoundPage from "@/pages/NotFoundPage";
import GonePage from "@/pages/GonePage";

export default function NotFoundOrRedirect() {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [redirect, setRedirect] = useState(null);
  const [type, setType] = useState(null);

  useEffect(() => {
    const checkRedirect = async () => {
      try {
        const res = await axios.get(`${API}/seo/check-redirect`, {
          params: { path: location.pathname }
        });
        
        if (res.data?.found) {
          setType(res.data.type);
          if (res.data.new_url) {
            setRedirect(res.data.new_url);
          }
        }
      } catch (err) {
        console.error("Error checking redirect", err);
      } finally {
        setLoading(false);
      }
    };

    checkRedirect();
  }, [location.pathname]);

  if (loading) {
    return (
      <div className="min-h-screen bg-[#050505] flex items-center justify-center">
        <Loader2 className="w-10 h-10 animate-spin text-[#00F0FF]" />
      </div>
    );
  }

  if (type === 410) {
    return <GonePage />;
  }

  if (redirect) {
    return <Navigate to={redirect} replace />;
  }

  // If no redirect found, show 404
  return <NotFoundPage />;
}
